import { render, staticRenderFns } from "./que.vue?vue&type=template&id=4064e1cc&scoped=true&"
import script from "./que.vue?vue&type=script&lang=js&"
export * from "./que.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4064e1cc",
  null
  
)

export default component.exports